import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { useStore } from "zustand";
import { OperationsShell } from "@/components/operations/operations-shell";
import { opsUiStore } from "@/lib/stores/ops-ui-store";

export const Route = createFileRoute("/operations/")({
	component: RouteComponent,
});

function RouteComponent() {
	const tabs = useStore(opsUiStore, (s) => s.tabs);
	const navigate = useStore(opsUiStore, (s) => s.navigate);

	// Open the dashboard by default when arriving with no tabs. Its access rung
	// is "all", so every ops user can see it.
	useEffect(() => {
		if (tabs.length === 0) {
			navigate({ type: "operationsDashboard" });
		}
	}, [tabs.length, navigate]);

	return <OperationsShell />;
}
